import React, { useState } from "react"; // Agregar useState
import { Swiper, SwiperSlide } from "swiper/react";
import { Typography } from "@material-tailwind/react";
import Modal from 'react-modal';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import welcome from '../videos/Welcome.mp4';
import libelium from '../videos/Libelium.mp4'
import Automatizacion from '../videos/Automatizacion.mp4'
import Ciberseguridad from '../videos/CyberpeaceV2.mp4'
import { Pagination, Navigation, EffectFade, Autoplay } from "swiper";
import { PlayCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
export default function Carousel() {

  const [modalIsOpen2, setModalIsOpen2] = useState(false);

  const closeModal = () => {
    setModalIsOpen2(false);
  };

  return (
    <>
      <Swiper
        effect="fade"
        slidesPerView={1}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 7000,
          disableOnInteraction: true,
        }}
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        loop
        className="h-screen"
      >

        <SwiperSlide>
          <div className="relative w-full h-full flex flex-col-reverse md:flex-row items-center ">
            <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover">
              <source src={welcome} type="video/mp4" />
              No pudimos cargar el video. Intenta con otro navegador.
            </video>
            <div className="absolute inset-0 flex flex-col items-center md:flex-row justify-center bg-black bg-opacity-50">
              <div className="md:items-start md:mx-auto md:w-1/3 items-center mx-4 lg:mx-auto order-1 lg:w-1/3 lg:order-2 md:mt-4 md:mb-2"></div>
              <div className="flex flex-col lg:w-3/5 xl:w-2/5 text-left mx-4 mb-4 lg:mx-auto">
                <Typography
                  variant="h1"
                  color="white"
                  className=" text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-4 ">
                  Tecnología que impulsa tu transformación digital
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl ">
                  En Voxcom desarrollamos soluciones en software, IoT, cloud, ciberseguridad y redes. Te acompañamos en cada etapa, desde la idea hasta la implementación y soporte, con resultados medibles y seguros.
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl mt-2">
                  {/* [Botón] */}
                </Typography>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative w-full h-full flex flex-col-reverse md:flex-row items-center ">
            <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover">
              <source src={libelium} type="video/mp4" />
              No pudimos cargar el video. Intenta con otro navegador.
            </video>
            <div className="absolute inset-0 flex flex-col items-center md:flex-row justify-center bg-black bg-opacity-50">
              <button className="md:items-start md:mx-auto md:w-1/3 items-center mx-4 lg:mx-auto order-1 lg:w-1/3 lg:order-2 md:mt-4 md:mb-2" onClick={() => setModalIsOpen2(true)}>
                <PlayCircleIcon className="w-10 md:w-16 xl:w-20 " color="white" />
              </button>
              <div className="flex flex-col lg:w-3/5 xl:w-2/5 text-left mx-4 mb-4 lg:mx-auto">
                <Typography
                  variant="h1"
                  color="white"
                  className=" text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-4 ">
                  Conecta y optimiza tus operaciones con IoT
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl ">
                  Integramos dispositivos de última generación junto a Libelium para agricultura, gestión del agua y ciudades inteligentes. Tecnología que captura datos en tiempo real y mejora la toma de decisiones.
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl mt-2">
                  {/* [Ver servicios IoT] */}
                </Typography>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative w-full h-full flex flex-col-reverse md:flex-row items-center ">
            <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover">
              <source src={Automatizacion} type="video/mp4" />
              No pudimos cargar el video. Intenta con otro navegador.
            </video>
            <div className="absolute inset-0 flex flex-col items-center md:flex-row justify-center bg-black bg-opacity-50">
              <button className="md:items-start md:mx-auto md:w-1/3 items-center mx-4 lg:mx-auto order-1 lg:w-1/3 lg:order-2 md:mt-4 md:mb-2" onClick={() => setModalIsOpen2(true)}>
                <PlayCircleIcon className="hidden w-10 md:w-16 xl:w-20 " color="white" />
              </button>
              <div className="flex flex-col lg:w-3/5 xl:w-2/5 text-left mx-4 mb-4 lg:mx-auto">
                <Typography
                  variant="h1"
                  color="white"
                  className=" text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-4 ">
                  Automatiza y agiliza la gestión de tus procesos clave
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl ">
                 Implementamos soluciones de automatización en colaboración con AuraQuantic para coordinar tareas, digitalizar flujos de trabajo y acelerar resultados, a través de plataformas flexibles que aumentan la productividad de tu organización.
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl mt-2">
                 {/* [Ver servicios TI] */}
                </Typography>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="relative w-full h-full flex flex-col-reverse md:flex-row items-center ">
            <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover">
              <source src={Ciberseguridad} type="video/mp4" />
              No pudimos cargar el video. Intenta con otro navegador.
            </video>
            <div className="absolute inset-0 flex flex-col items-center md:flex-row justify-center bg-black bg-opacity-50">
              <button className="md:items-start md:mx-auto md:w-1/3 items-center mx-4 lg:mx-auto order-1 lg:w-1/3 lg:order-2 md:mt-4 md:mb-2" onClick={() => setModalIsOpen2(true)}>
                <PlayCircleIcon className="hidden w-10 md:w-16 xl:w-20 " color="white" />
              </button>
              <div className="flex flex-col lg:w-3/5 xl:w-2/5 text-left mx-4 mb-4 lg:mx-auto">
                <Typography
                  variant="h1"
                  color="white"
                  className=" text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-4 ">
                  Ciberseguridad que inspira confianza digital en Chile
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl ">
                 Trabajamos junto a Cyberpeace para implementar servicios especializados que fortalecen tus defensas, cumplen con la Ley Marco de Ciberseguridad y la Ley de Protección de Datos Personales, y protegen tus activos críticos frente a amenazas emergentes.
                </Typography>
                <Typography
                  variant="paragraph"
                  color="white"
                  className=" font-mono text-base md:text-lg lg:text-xl mt-2">
                 {/* [Ver servicios de Ciberseguridad] */}
                </Typography>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <Modal
        isOpen={modalIsOpen2}
        onRequestClose={() => setModalIsOpen2(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 1000,
          },
          content: {
            width: "70%",
            height: "70%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "none",
            background: "transparent",
          },
        }}
      >
        <button className="absolute top-0 right-0" onClick={closeModal}>
          <XCircleIcon className="w-7" color="white" />
        </button>
        <iframe style={{ width: "100%", height: "100%" }} src="https://www.youtube.com/embed/dh5YMuN0fgs?si=4Ic0o4Gy7Ajum_1Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </Modal>
    </>
  );
}